import { InjectionToken } from '@angular/core';

/**
 * Whether the AI Data Analyst is available to this customer — gates the floating chat bubble (and
 * anything else that should disappear when the feature is off).
 *
 * OFF by default: the token's own factory default is `false`, so a customer only gets the assistant
 * by explicitly opting IN from their customer-init module —
 *
 *   { provide: AI_ANALYST_ENABLED, useValue: true }
 *
 * The default lives here (not just in each customer module) so that a new customer, or any host that
 * forgets to provide it, ships WITHOUT the assistant rather than accidentally exposing a
 * half-configured feature. Consumers still inject it `@Optional()` for safety, but the factory means
 * the token always resolves to `false` when unprovided.
 */
export const AI_ANALYST_ENABLED = new InjectionToken<boolean>('ai-analyst-enabled', {
	providedIn: 'root',
	factory:    () => false
});
